import { ENV } from '@wolffun/env-var';
const nonLiveConfig = {
  apiKey: 'AIzaSyCCtHeeoar-a8sjz4_IThjyCdlmwvxxuWo',
  authDomain: 'thetan-arena.firebaseapp.com',
  projectId: 'thetan-arena',
  storageBucket: 'thetan-arena.appspot.com',
  messagingSenderId: '543249830504',
  appId: '1:543249830504:web:a52455b9916a97a046a1dd',
  measurementId: 'G-8VGWVWTJPG'
};
const liveConfig = {
  apiKey: 'AIzaSyCCtHeeoar-a8sjz4_IThjyCdlmwvxxuWo',
  authDomain: 'thetan-arena.firebaseapp.com',
  projectId: 'thetan-arena',
  storageBucket: 'thetan-arena.appspot.com',
  messagingSenderId: '543249830504',
  appId: '1:543249830504:web:8cb54f5c4999df8f46a1dd',
  measurementId: 'G-Q0TW0GSG2G'
};
export const getConfig = () => {
  return ENV === 'production' ? liveConfig : nonLiveConfig;
};